import { DownOutlined, PlusOutlined, SearchOutlined, SettingOutlined } from '@ant-design/icons';
import { ColDef, GridApi, SelectionChangedEvent } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { ConfigProvider, Input, Pagination, Select, TreeSelect } from 'antd';
import viVN from 'antd/locale/vi_VN';
import dayjs from 'dayjs';
import { memo, useCallback, useEffect, useRef, useState } from 'react';
import { ISelectOption } from '../../../../../../api/selectOptions/selectOptionsApi';
import { dataPagination, formatPrice } from '../../../../../../until';
import { IDataFilterGroupList, IPagination } from '../../AddGroup/AddNewGroup';
import '../../../style.scss';
import { NodataTable } from '../../../../../../components/NoDataTable';
import { useCustomerGroupContext } from '../../../indexV2';
import ModalAddCustomersManually from '../../Modal/ModalAddCustomersManually';
import NoCondition_ModalAddCustomersManually from '../Modal/NoCondition_ModalAddCustomersManually';
import { AddType, ISelectedCustomer } from '../EditGroup';
import { formatNumber } from '../../../../../../services/mixin';
dayjs.locale('vi');

interface props {
    sLCategoryCar: ISelectOption[]

    memoizedColumnDefs?: ColDef<any, any>[]
    selectedIdCustomerV9: ISelectedCustomer[]

    paginationCustomer: IPagination
    // selectedIdCustomerV9: Set<number>

    setSelectedIdCustomerV9: React.Dispatch<React.SetStateAction<ISelectedCustomer[]>>
    onPaginationCustomers?: ((page: number, pageSize: number) => void)

    //Kh không dk
    tableDataNoCondCustomer?: any[]
    paginationNoCondCustomerManual: IPagination
    dataFilterListNoCondCustomers: IDataFilterGroupList
    dataFilterListNoCondCustomerManual: IDataFilterGroupList
    selectedIdNoCondCustomerManual: Set<number>
    tableDataNoCondCustomerManual: any[]

    setDataFilterListNoCondCustomers?: (dataFilterList: IDataFilterGroupList) => void
    setDataFilterListNoCondCustomerManual: (dataFilterList: IDataFilterGroupList) => void
    handleChangeNoCondSelectIdCustomerManual: (data: Set<number>) => void
    onPaginationNoCondChangeManual?: ((page: number, pageSize: number) => void)
    //Kh không dk
}

const EG_PrivateNoAutomatic: React.FC<props> = ({
    sLCategoryCar,
    memoizedColumnDefs,
    paginationCustomer, selectedIdCustomerV9,
    setSelectedIdCustomerV9,
    onPaginationCustomers,

    //Kh không dk
    tableDataNoCondCustomer,
    paginationNoCondCustomerManual,
    dataFilterListNoCondCustomers,
    dataFilterListNoCondCustomerManual,
    selectedIdNoCondCustomerManual,
    tableDataNoCondCustomerManual,

    setDataFilterListNoCondCustomers,
    setDataFilterListNoCondCustomerManual,
    onPaginationNoCondChangeManual,
    handleChangeNoCondSelectIdCustomerManual,
    //Kh không dk
}) => {
    const {
        handleOpenDataFields
    } = useCustomerGroupContext();

    const [isModalAddCustomersManually, setModalAddCustomersManually] = useState<boolean>(false)
    const [selectedIds, setSelectedIds] = useState<Set<Number>>(new Set());

    const [selectedIdUnmatchedCustomers, setSelectedIdUnmatchedCustomers] = useState<Set<number>>(new Set());
    const gridApiRef = useRef<GridApi | null>(null);
    const isRestoringSelection = useRef(false);
    const {
        // sLUnit 
        sLNationwide

    } = useCustomerGroupContext();
    //------------------------------------
    // Định danh duy nhất cho mỗi row
    const getRowId = useCallback((p: { data: any }) => String(p.data.id), []);

    // --- Grid ready ---
    const onGridReady = useCallback((params: { api: GridApi }) => {
        gridApiRef.current = params.api;
    }, []);

    // --- Selection change ---
    const onSelectionChanged = useCallback((event: SelectionChangedEvent) => {
        if (isRestoringSelection.current) return;

        const api = event.api;
        const selectedNodes = api.getSelectedNodes().filter(n => n.data);
        const selectedIdsOnPage = selectedNodes.map(n => Number(n.data.id));

        const currentPageIds = (tableDataNoCondCustomer ?? []).map((row: any) => Number(row.id));

        // --- Tạo bản sao của selectedIds hiện tại ---
        const nextSet = new Set(selectedIds);

        // --- Xác định phần tử được thêm và bị xóa trên trang HIỆN TẠI ---
        const added: number[] = [];
        const removed: number[] = [];

        // Kiểm tra từng ID trên trang hiện tại
        for (const id of currentPageIds) {
            const isCurrentlySelected = selectedIdsOnPage.includes(id);
            const wasPreviouslySelected = selectedIds.has(id);

            if (isCurrentlySelected && !wasPreviouslySelected) {
                // ID mới được chọn
                added.push(id);
                nextSet.add(id);
            } else if (!isCurrentlySelected && wasPreviouslySelected) {
                // ID bị bỏ chọn
                removed.push(id);
                nextSet.delete(id);
            }
        }

        setSelectedIds(nextSet);


        // 👉 Cập nhật danh sách selected account
        handleChangeSelectedCustomer(added, removed);

    }, [selectedIdCustomerV9, tableDataNoCondCustomer]);
    //------------------------------------

    // --- Cập nhật danh sách account được chọn ---
    const handleChangeSelectedCustomer = (itemsAdd: number[] = [], itemsRemove: number[] = []) => {
        setSelectedIdCustomerV9((prev) =>
            itemsAdd.length ?
                [
                    ...prev,
                    ...itemsAdd
                        .filter((id) => !prev.some((u) => u.customerId === id))
                        .map((id) => ({ customerId: id, addType: AddType.Manual })),
                ] :
                itemsRemove.length ?
                    prev.filter((u) => !itemsRemove.includes(u.customerId)) :
                    prev
        );
    };

    // --- Khôi phục selection khi data mới load ---
    useEffect(() => {
        if (gridApiRef.current && tableDataNoCondCustomer && tableDataNoCondCustomer.length > 0) {
            isRestoringSelection.current = true;

            gridApiRef.current.forEachNode((node: any) => {
                if (node.data) {
                    const nodeId = Number(node.data.id);
                    const shouldBeSelected = selectedIdCustomerV9.some(item => item.customerId === nodeId);

                    if (shouldBeSelected) {
                        node.setSelected(true, false, true);
                    } else {
                        node.setSelected(false, false, true);
                    }
                }
            });

            // Refresh grid để hiển thị selection
            gridApiRef.current.refreshCells({ force: true });

            setTimeout(() => {
                isRestoringSelection.current = false;
            }, 100);
        }
    }, [tableDataNoCondCustomer, selectedIdCustomerV9]);


    // --- Đồng bộ selectedIds với selectedIdCustomerV9 ---
    useEffect(() => {
        const idsFromSelectedCustomerV9 = new Set(
            selectedIdCustomerV9.map(item => item.customerId)
        );
        setSelectedIds(idsFromSelectedCustomerV9);
    }, [selectedIdCustomerV9]);



    return (
        <div className="custom-page-css w-full flex flex-col gap-2 bg-white p-4 rounded">
            {/* <NoCondition_ModalAddCustomersManually
                isOpen={isModalAddCustomersManually}
                sLUnit={sLNationwide}
                sLCategoryCar={sLCategoryCar}
                memoizedColumnDefs={memoizedColumnDefs}

                //Kh không dk
                paginationNoCondCustomerManual={paginationNoCondCustomerManual}
                dataFilterListNoCondCustomerManual={dataFilterListNoCondCustomerManual}
                selectedIdNoCondCustomerManual={selectedIdNoCondCustomerManual}
                tableDataNoCondCustomerManual={tableDataNoCondCustomerManual}


                setDataFilterListNoCondCustomerManual={setDataFilterListNoCondCustomerManual}
                handleChangeNoCondSelectIdCustomerManual={handleChangeNoCondSelectIdCustomerManual}
                onPaginationNoCondChangeManual={onPaginationNoCondChangeManual}
                //Kh không dk


                closeModal={setModalAddCustomersManually}
            /> */}
            <div className="custom-page-css flex gap-2 items-center">
                <span className='custom-page-css text-base font-regular'>Danh sách khách hàng</span>

            </div>
            {/* Filters */}
            <div className="custom-page-css flex items-start gap-2">
                <div className="custom-page-css h-fit flex-1 d-flex  gap-2 overflow-hidden">
                    <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center  py-2-px justify-between overflow-hidden">
                        <div className="d-flex align-center w-full">

                            <TreeSelect
                                className="w-full text-left text-span-select custom-input-focus text-sm bg-FCFCFD-ant-select font-regular p-none-select line-none line-none-item inline-none size-selector border-none"
                                multiple
                                showSearch
                                placeholder="Chọn đơn vị"
                                allowClear
                                value={dataFilterListNoCondCustomers?.listUnit}
                                treeDefaultExpandAll={false}
                                treeData={sLNationwide}
                                filterTreeNode={(input: string, option: any) =>
                                    typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                onChange={(e) => setDataFilterListNoCondCustomers?.({ ...dataFilterListNoCondCustomers, listUnit: e })}
                            />

                        </div>
                    </div>
                </div>
                <div className="custom-page-css h-fit flex-1 d-flex gap-2 overflow-hidden">
                    <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center  py-2-px justify-between overflow-hidden">
                        <div className="d-flex align-center w-full">
                            <Select
                                showSearch={false}
                                allowClear
                                mode="multiple"
                                className="w-full text-left text-span-select text-sm bg-FCFCFD-ant-select font-regular p-none-select line-none line-none-item inline-none size-selector border-none"
                                popupClassName='position-dropdow custome-select-item h-popUp'
                                variant="borderless"
                                placeholder="Thương hiệu"
                                options={sLCategoryCar}
                                value={dataFilterListNoCondCustomers?.listCategoryCar}
                                onChange={(e) => setDataFilterListNoCondCustomers?.({ ...dataFilterListNoCondCustomers, listCategoryCar: e })}
                            />

                        </div>
                    </div>
                </div>
                <div className="custom-page-css h-fit flex-2 border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3 py-2-px justify-between overflow-hidden">
                    <Input
                        placeholder="Tìm kiếm thông tin khách hàng "
                        className='custom-input-css custom-page-css border-none custom-input-focus  none-focus-erro'
                        value={dataFilterListNoCondCustomers?.search}
                        onChange={(e) => setDataFilterListNoCondCustomers?.({ ...dataFilterListNoCondCustomers, search: e.target.value })}
                    />
                    <div className=" border-l-F2F4F7 h-full d-flex align-center">
                        <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
                    </div>
                </div>

            </div>
            <div className="custom-page-css flex items-center gap-1">

            </div>
            <div className="custom-page-css flex items-center justify-betweeen gap-1">
                <div className="custom-page-css flex items-center gap-1">
                    <span className='custom-page-css text-base text-4B4B4B font-regular'>Đã chọn:</span>
                    <span className='custom-page-css text-base text-344054 font-regular'>{formatPrice(selectedIdCustomerV9.length)} khách hàng</span>
                </div>
                <div className="custom-page-css flex items-center justify-end gap-2">
                    <div className="custom-page-css flex items-center justify-end gap-2">
                        {/* <div className="custom-page-css flex items-center gap-1 cursor-pointer"
                            onClick={() => setModalAddCustomersManually(true)}
                        >
                            <div className="custom-page-css flex items-center justify-center  p-2px rounded-full bg-E1E4E9 "

                            >
                                <PlusOutlined style={{ color: '#98A2B3' }} />
                            </div>
                            <span className="custom-page-css text-base text-667085 font-medium">Thêm khách hàng thủ công</span>
                        </div> */}
                        <div className="btn-input t-px-8 cursor-pointer"
                            onClick={handleOpenDataFields}
                        >
                            <div className="icon-svg">
                                <SettingOutlined />
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div className="ag-theme-alpine custom-table-ag">
                <AgGridReact
                    domLayout="autoHeight"
                    className="my-auto-height-grid"
                    getRowStyle={(params: any) => ({
                        backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
                    })}
                    rowData={tableDataNoCondCustomer}
                    columnDefs={memoizedColumnDefs}
                    rowHeight={55}
                    defaultColDef={{
                        resizable: true
                    }}
                    overlayNoRowsTemplate={NodataTable}
                    rowSelection={{ mode: 'multiRow' }} selectionColumnDef={{ pinned: 'left', lockPosition: 'left', suppressMovable: true }}
                    getRowId={getRowId}
                    onGridReady={onGridReady}
                    onSelectionChanged={onSelectionChanged}
                />
            </div>
            <ConfigProvider locale={viVN}>
                <div className="pagination-block">
                    <Pagination
                        showSizeChanger
                        current={paginationCustomer?.current}
                        pageSize={paginationCustomer?.pageSize}
                        total={paginationCustomer?.total}
                        itemRender={(page, type, originalElement) => {
                            // Chỉ custom khi là nút số trang
                            if (type === 'page') {
                                return <span>{formatNumber(page)}</span>;
                            }
                            // prev / next / jump-prev / jump-next giữ nguyên
                            return originalElement;
                        }}
                        showTotal={(total) => `Tổng cộng ${dataPagination(paginationCustomer.total, paginationCustomer.pageSize, paginationCustomer.current).totalPage} trang`}
                        className='rs-pagination'
                        onChange={onPaginationCustomers}
                    />
                </div>
            </ConfigProvider>
        </div>
    )
}

export default memo(EG_PrivateNoAutomatic) 
